import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { NavigationAction } from "stores/Navigation/NavigationAction";
const mapStateToProps = (state) => {
    
  return {
    NavigationDataList: state.NavigationData.NavigationDataList,
    isLoading:state.NavigationData.NavigationdataLoading.isLoading
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getNavigationDataAction:NavigationAction.getNavigationData
}, dispatch);

const NavigationStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default NavigationStore;
 